import { TuiButtonModule, TuiHintModule } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'wo-table-action',
  templateUrl: './table-action.component.html',
  styleUrls: [ './table-action.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiButtonModule,
    IconComponent,
    TuiHintModule,
  ],
})
export class TableActionComponent {
  @Input({ required: true }) public icon!: IconName;
  @Input({ required: true }) public tooltip!: string;
}
